// extracted by mini-css-extract-plugin
module.exports = {"cancel_subscription":"styles_cancel_subscription__2sD01"};